import { render, staticRenderFns } from "./Salesman.vue?vue&type=template&id=35de57de&"
import script from "./Salesman.vue?vue&type=script&lang=js&"
export * from "./Salesman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports